import { render, staticRenderFns } from "./DocenteEditarTutoriaDisponibilidad.vue?vue&type=template&id=851f7936&"
import script from "./DocenteEditarTutoriaDisponibilidad.vue?vue&type=script&lang=js&"
export * from "./DocenteEditarTutoriaDisponibilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports